import i18next from 'i18next';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
export default {
    deleteColumnSet(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DELETE_COLUMN_SET,
            result,
        });
    },
    updateColumnSet(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_COLUMN_SET,
            result,
        });
    },
    getColumnSet(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_COLUMN_SET,
            result,
        });
    },
    errorColumnSet(e) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ERROR_COLUMN_SET,
            e,
        });
    },
    createColumnSet(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_COLUMN_SET,
            result,
        });
    },
    setUVDateTo(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SET_UV_DATE_TO,
            result,
        });
    },
    setUVDateFrom(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SET_UV_DATE_FROM,
            result,
        });
    },
    UVDateChanged(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UV_DATE_UPDATE,
            result,
        });
    },
    alertDrayageDataUpdate() {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GRID_UPDATE,
            result: {},
        });
    },
    /*
     * @alertFiltersCreated alerts FiltersStore when new filter created
     */
    alertFiltersCreated(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FILTER_CREATED,
            result,
        });
    },
    /*
     * @alertFiltersDeleted alerts FiltersStore when filter deleted
     * @params { result } is an id of the filter to be removed from filterstore
     */
    alertFiltersDeleted(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FILTER_DELETED,
            result,
        });
    },
    getAllFiltersSuccess(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_ALL_FILTERS_SUCCESS,
            result,
        });
    },
    alertFiltersCrudFail(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FILTERS_FAILURE,
            result,
        });
    },
    generateDeliveryOrderSuccess(job) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_DELIVERY_ORDER_SUCCESS,
            job,
        });
    },
    generateDeliveryOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_DELIVERY_ORDER_FAIL,
            error,
        });
    },
    generateCustomDeliveryOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_CUSTOM_DELIVERY_ORDER_SUCCESS,
            order,
        });
    },
    generateCustomDeliveryOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_CUSTOM_DELIVERY_ORDER_FAIL,
            error,
        });
    },
    emailCustomDeliveryOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.EMAIL_CUSTOM_DELIVERY_ORDER_SUCCESS,
            order,
        });
    },
    emailCustomDeliveryOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.EMAIL_CUSTOM_DELIVERY_ORDER_FAIL,
            error,
        });
    },
    generateOrderInvoiceSuccess({ invoice, order }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_ORDER_INVOICE_SUCCESS,
            ledger: invoice,
            order,
        });
    },
    generateOrderInvoiceFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_ORDER_INVOICE_FAIL,
            error,
        });
    },
    generateOrderPayoutSuccess({ payout, order }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_ORDER_PAYOUT_SUCCESS,
            ledger: payout,
            order,
        });
    },
    generateOrderPayoutFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_ORDER_PAYOUT_FAIL,
            error,
        });
    },
    fetchOrdersSuccess(payload) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDERS_SUCCESS,
            payload,
        });
    },
    fetchOrdersFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDERS_FAIL,
            error,
        });
    },
    fetchOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_SUCCESS,
            order,
        });
    },
    fetchOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_FAIL,
            error,
        });
    },
    createOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ORDER_SUCCESS,
            order,
        });
    },
    createOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ORDER_FAIL,
            error,
        });
    },
    createQuoteSuccess(quote) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_QUOTE_SUCCESS,
            quote,
        });
    },
    createQuoteFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_QUOTE_FAIL,
            error,
        });
    },
    updateQuoteSuccess(quote) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_QUOTE_SUCCESS,
            quote,
        });
    },
    updateQuoteFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_QUOTE_FAIL,
            error,
        });
    },
    deleteQuoteSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DELETE_QUOTE_SUCCESS,
            response,
        });
    },
    deleteQuoteFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DELETE_QUOTE_FAIL,
            response,
        });
    },
    saveTemplateAndBookOrderSuccess({ order, template }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SAVE_TEMPLATE_AND_BOOK_ORDER_SUCCESS,
            order,
            template,
        });
    },
    saveTemplateAndBookOrderFail({ order, error }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SAVE_TEMPLATE_AND_BOOK_ORDER_FAIL,
            order,
            error,
        });
    },
    createOrderAndTemplateSuccess({ order, template }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ORDER_AND_TEMPLATE_SUCCESS,
            order,
            template,
        });
    },
    createOrderAndTemplateFail({ order, error }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ORDER_AND_TEMPLATE_SUCCESS,
            order,
            error,
        });
    },
    cancelOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CANCEL_ORDER_SUCCESS,
            order,
        });
    },
    cancelOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CANCEL_ORDER_FAIL,
            error,
        });
    },
    reopenOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REOPEN_ORDER_SUCCESS,
            order,
        });
    },
    reopenOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REOPEN_ORDER_FAIL,
            error,
        });
    },
    transitionOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TRANSITION_ORDER_SUCCESS,
            order,
        });
    },
    transitionOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TRANSITION_ORDER_FAIL,
            error,
        });
    },
    updateOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ORDER_SUCCESS,
            order,
        });
    },
    updateOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ORDER_FAIL,
            error,
        });
    },
    uploadOrderDocumentSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPLOAD_ORDER_DOCUMENT_SUCCESS,
            order,
        });
    },
    uploadOrderDocumentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPLOAD_ORDER_DOCUMENT_FAIL,
            error,
        });
    },
    deleteOrderDocumentSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DELETE_ORDER_DOCUMENT_SUCCESS,
            order,
        });
    },
    deleteOrderDocumentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DELETE_ORDER_DOCUMENT_FAIL,
            error,
        });
    },
    addOrderCommentSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_ORDER_COMMENT_SUCCESS,
            order,
        });
    },
    addOrderCommentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_ORDER_COMMENT_FAIL,
            error,
        });
    },
    addEquipmentToOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_ORDER_EQUIPMENT_SUCCESS,
            order,
        });
    },
    addEquipmentToOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_ORDER_EQUIPMENT_FAIL,
            error,
        });
    },
    removeEquipmentFromOrderSuccess(order) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_ORDER_EQUIPMENT_SUCCESS,
            order,
        });
    },
    removeEquipmentFromOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_ORDER_EQUIPMENT_FAIL,
            error,
        });
    },
    findMarketSuccess(market) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FIND_MARKET_SUCCESS,
            market,
        });
    },
    findMarketFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FIND_MARKET_FAIL,
            error,
        });
    },
    receiveAllLocations(locations) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_LOCATIONS_LIST,
            locations,
        });
    },
    receiveLocation(location) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_LOCATION,
            location,
        });
    },
    receiveAllEquipment(equipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ALL_EQUIPMENT,
            equipment,
        });
    },
    addEquipmentForStagingStopSuccess(equipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_EQUIPMENT,
            equipment,
        });
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_EQUIPMENT_FOR_STAGING_STOP_SUCCESS,
            equipment,
        });
    },
    addEquipment(equipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_EQUIPMENT,
            equipment,
        });
    },
    updateEquipment(equipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_EQUIPMENT,
            equipment,
        });
    },
    updateEquipmentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_EQUIPMENT_FAIL,
            error,
        });
    },
    bulkUpdateEquipments(results) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_EQUIPMENTS,
            results,
        });
    },
    bulkUpdateEquipmentsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_EQUIPMENTS_FAIL,
            error,
        });
    },
    addEquipmentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_EQUIPMENT_FAIL,
            error,
        });
    },
    receiveUserSuccess(user) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_USER_PROFILE,
            user,
        });
    },
    createCarrierSuccess(carrier) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATED_CARRIER,
            carrier,
        });
    },
    updateUserSuccess(user) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_USER_SUCCESS,
            user,
        });
    },
    updateUserFailure(user) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_USER_FAILURE,
            user,
        });
    },
    updateNotificationSuccess(user) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_NOTIFICATIONS_SUCCESS,
            user,
        });
    },
    receiveUpdateCarrierSuccess(jobs) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_UPDATE_JOBS_CARRIER_SUCCESS,
            jobs,
        });
    },
    receiveUpdateCarrierFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_UPDATE_JOBS_CARRIER_FAIL,
            error,
        });
    },
    receiveUpdateConsigneeSuccess(jobs) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_UPDATE_JOBS_CONSIGNEE_SUCCESS,
            jobs,
        });
    },
    receiveUpdateConsigneeFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_UPDATE_JOBS_CONSIGNEE_FAIL,
            error,
        });
    },
    receiveUpdateShipperSuccess(jobs) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_UPDATE_JOBS_SHIPPER_SUCCESS,
            jobs,
        });
    },
    receiveCustomers(customers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CUSTOMER_LIST,
            customers,
        });
    },
    updateNotificationFail(err) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_NOTIFICATIONS_FAIL,
            err,
        });
    },
    driverManifestDepartSuccess(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DRIVER_MANIFEST_DEPART_SUCCESS,
            message,
        });
    },
    driverManifestDepartFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DRIVER_MANIFEST_DEPART_FAIL,
            message,
        });
    },
    driverManifestAlreadyDepartError(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DRIVER_MANIFEST_ALREADY_DEPART_ERROR,
            message,
        });
    },
    loginSuccess(token, user) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.LOGIN_SUCCESS,
            token,
            user,
        });
    },
    loginFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.LOGIN_FAIL,
            message,
        });
    },
    receivePasswordResetRequestFailure(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.PASSWORD_RESET_REQUEST_FAILURE,
            message: response,
        });
    },
    receivePasswordResetRequestSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.PASSWORD_RESET_REQUEST_SUCCESS,
            message: response,
        });
    },
    receivePasswordChangeSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.PASSWORD_CHANGE_SUCCESS,
            message: response,
        });
    },
    receivePasswordChangeFailure(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.PASSWORD_CHANGE_FAILURE,
            message: response,
        });
    },
    authCheckSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.AUTH_CHECK_SUCCESS,
            response,
        });
    },
    authCheckFailed(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.AUTH_CHECK_FAILED,
            response,
        });
    },
    receiveAllShipments(shipments) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ALL_SHIPMENTS,
            shipments,
        });
    },
    receiveTimelineAddFailure(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_TIMELINE_ADD_FAILURE,
            error,
        });
    },
    receiveExceptionsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ALL_SHIPMENTS,
            shipments: response.jobs,
        });
    },
    resolveException(exceptionId) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RESOLVE_EXCEPTION,
            exceptionId,
        });
    },
    resolveExceptions(exceptionIds) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RESOLVE_EXCEPTIONS,
            exceptionIds,
        });
    },
    processBolSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_BILL_OF_LADING_SUCCESS,
            bol: response.bol,
        });
    },
    processBolSentSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_BILL_OF_LADING_SENT_SUCCESS,
            bol: response.bol,
        });
    },
    processBolFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_BILL_OF_LADING_FAIL,
            bol: response.bol,
        });
    },
    sendRateConfirmationSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_RATE_CONFIRMATION_SUCCESS,
            rateConfirmation: response.rateConfirmation,
        });
    },
    sendRateConfirmationSentSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_RATE_CONFIRMATION_SENT_SUCCESS,
            rateConfirmation: response.rateConfirmation,
        });
    },
    sendRateConfirmationFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_RATE_CONFIRMATION_FAIL,
            rateConfirmation: response.rateConfirmation,
        });
    },
    carrierReceviedEmail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SEND_ACCESORIAL_APPROVAL_SUCCESS,
            shipment: response.job,
        });
    },
    receiveSendDeliveryOrderSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SEND_DELIVERY_ORDER_SUCCESS,
            shipment: response.job,
        });
    },
    receiveShipmentStopCompleteFailure(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_STOP_COMPLETE_FAILURE,
            error: i18next.t('FAILED_TO_COMPLETE_STOP', {
                message: response.message,
            }),
        });
    },
    receiveShipmentStopCompleteSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_STOP_COMPLETE_SUCCESS,
            shipment: response.job,
        });
    },
    receiveShipmentSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT,
            shipment: response.job,
        });
    },
    receiveMassShipmentsSuccess(stopAction, response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_MASS_UPDATE_SUCCESS,
            stopAction,
            response,
        });
    },
    receiveBulkTransitionShipmentsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_BULK_TRANSITION_SUCCESS,
            response,
        });
    },
    receiveShipmentCloneSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_CLONE_SUCCESS,
            shipment: response.job,
            clones: response.clones,
        });
    },
    receivePickUpExceptionsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ALL_SHIPMENTS,
            shipments: response.jobs,
        });
    },
    receiveShipmentCanceledSuccess(shipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SHIPMENT_CANCEL_SUCCESS,
            shipment,
        });
    },
    receiveShipmentCanceledFailure(shipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SHIPMENT_CANCEL_FAILURE,
            shipment,
        });
    },
    receiveShipmentCloseSuccess(shipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SHIPMENT_CLOSE_SUCCESS,
            shipment,
        });
    },
    receiveShipmentCloseFailure(shipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SHIPMENT_CLOSE_FAILURE,
            shipment,
        });
    },
    receiveDriverManifest(manifest) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DRIVER_MANIFEST,
            data: manifest,
        });
    },
    receiveDepartedManifest(manifest) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DEPARTED_MANIFEST,
            data: manifest,
        });
    },
    receiveDriver(driver) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DRIVER,
            driver,
        });
    },
    receiveDriversSuccess(drivers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DRIVERS,
            drivers,
        });
    },
    receiveAuthorizedDriversSuccess(drivers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_AUTHORIZED_DRIVERS,
            drivers,
        });
    },
    receiveAvailableDriversSuccess(drivers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_AVAILABLE_DRIVERS,
            drivers,
        });
    },
    receiveNearbyDriversForCarrierSuccess(drivers, count) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_NEARBY_CARRIER_DRIVERS,
            drivers,
            count,
        });
    },
    receiveNearbyDriversSuccess(drivers, count) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_NEARBY_DRIVERS,
            drivers,
            count,
        });
    },
    assignDriverSuccess(shipment, driver) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ASSIGN_DRIVER_SUCCESS,
            driver,
            shipment,
        });
    },
    assignDriverFail(payload) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ASSIGN_DRIVER_FAIL,
            payload,
        });
    },
    acceptOfferSuccess(payload) {
        AdminAppDispatcher.handleServerAction(Object.assign({ type: ActionTypes.ACCEPT_OFFER_SUCCESS }, payload));
    },
    acceptOfferFail(payload) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ACCEPT_OFFER_FAIL,
            payload,
        });
    },
    receiveShipmentUpdate(shipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_UPDATE,
            shipment,
        });
    },
    receiveShipmentUpdateError(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_UPDATE_ERROR,
            error,
        });
    },
    receiveOffers(offers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_OFFERS,
            offers,
        });
    },
    receiveOffer(offer) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_OFFER,
            offer,
        });
    },
    createOrderShipmentSuccess(offer) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ORDER_SHIPMENT_SUCCESS,
            offer,
        });
        const { order: { _id: orderId }, } = offer;
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.FETCH_ORDER_SHIPMENTS_REQUEST,
            orderId,
        });
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.FETCH_ORDER_REQUEST,
            orderId,
        });
    },
    createOrderShipmentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ORDER_SHIPMENT_FAIL,
            error,
        });
    },
    createShipmentFromOrderSuccess(results) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_SHIPMENT_FROM_ORDER_SUCCESS,
            results,
        });
    },
    createShipmentFromOrderFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_SHIPMENT_FROM_ORDER_FAIL,
            error,
        });
    },
    receiveCreatedOffer(offer) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CREATED_OFFER,
            offer,
        });
    },
    createOfferFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_OFFER_FAIL,
            message,
        });
    },
    receiveCreateException(exception) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CREATE_EXCEPTION,
            exception,
        });
    },
    receiveExceptions(exceptions, pages, meta) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_EXCEPTIONS,
            exceptions,
            pages,
            meta,
        });
    },
    receiveException(exception) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_EXCEPTION,
            exception,
        });
    },
    receivePayout(payout) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_PAYOUT,
            data: payout,
        });
    },
    receivePayouts(payouts) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_PAYOUTS,
            data: payouts,
        });
    },
    receiveInvoice(invoice) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_INVOICE,
            data: invoice,
        });
    },
    addPayouts(payouts) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_PAYOUTS,
            data: payouts,
        });
    },
    receiveInvoices(invoices) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_INVOICES,
            data: invoices,
        });
    },
    receiveOfferUpdate(shipment) {
        // TODO see receiveShipment
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_OFFER,
            shipment,
        });
    },
    receiveSalespeople(users) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SALES_REPS,
            users,
        });
    },
    emailSent(to) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.EMAIL_SENT,
            to,
        });
    },
    emailFailed(to) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.EMAIL_FAIL,
            to,
        });
    },
    receiveCustomer(customer) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CUSTOMER,
            shipper: customer,
        });
    },
    updateCustomer(customer) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_CUSTOMER,
            shipper: customer,
        });
    },
    receiveShipper(shipper) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPPER,
            shipper,
        });
    },
    receiveShipperQuotes(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPPER_QUOTES,
            result,
        });
    },
    receiveQuotesAfterUpdate(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_QUOTE_AFTER_UPDATE_SUCCESS,
            result,
        });
    },
    receiveQuote(quote) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_QUOTE_SUCCESS,
            quote,
        });
    },
    receiveQuoteFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_QUOTE_FAIL,
            error,
        });
    },
    receiveShippers(entity) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPPERS,
            shippers: entity.data,
            count: entity.meta ? entity.meta.count : 0,
        });
    },
    receiveCarrier(carrier) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CARRIER,
            carrier,
        });
    },
    receiveCarrierRMIS(carrierRMIS) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CARRIER_RMIS,
            carrierRMIS,
        });
    },
    receiveCarriers(carriers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CARRIERS,
            carriers,
        });
    },
    receiveLocations(locations) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_LOCATIONS,
            locations,
        });
    },
    receiveAdminUser(user) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ADMIN_USER,
            user,
        });
    },
    receiveAdminUsers(users) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ADMIN_USERS,
            users,
        });
    },
    receiveUsersWithTariff(users) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_USERS_WITH_TARIFF,
            users,
        });
    },
    updatedShipper(id, shipper) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_SHIPPER,
            id,
            shipper,
        });
    },
    updatedVendor(id, vendor) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_VENDOR,
            id,
            vendor,
        });
    },
    updatedCarrier(id, carrier) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_CARRIER,
            id,
            carrier,
        });
    },
    updateCarrierFailed(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_CARRIER_FAILED,
            error,
        });
    },
    addedCarrierPortProData(carrier) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADDED_CARRIER_PORTPRO_DATA,
            carrier,
        });
    },
    addedCarrierPortProDataFailed(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_CARRIER_PORTPRO_DATA_FAILED,
            error,
        });
    },
    changedPortProEnabling(enabled) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CHANGED_PORTPRO_ENABLING,
            enabled,
        });
    },
    changedPortProEnablingFailed(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CHANGE_PORTPRO_ENABLING_FAILED,
            error,
        });
    },
    savePortProIntegration(carrier) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SAVE_PORTPRO_INTEGRARION,
            carrier,
        });
    },
    savePortProIntegrationFailed(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SAVE_PORTPRO_INTEGRARION_FAILED,
            error,
        });
    },
    updateCarrierDocumentsSuccess(id, carrier) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_CARRIER_DOCUMENTS_SUCCESS,
            id,
            carrier,
        });
    },
    updateCarrierDocumentsFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_CARRIER_DOCUMENTS_FAILED,
            data,
        });
    },
    updatedDriver(id, driver) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_DRIVER,
            id,
            driver,
        });
    },
    updateDriverFailed(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_DRIVER_FAILED,
            error,
        });
    },
    uploadShipmentDocumentsSuccess({ shipment, shipmentId }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPLOAD_SHIPMENT_DOCUMENT_SUCCESS,
            shipment,
            shipmentId,
        });
    },
    uploadShipmentDocumentsFail(shipmentId) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPLOAD_SHIPMENT_DOCUMENT_FAIL,
            shipmentId,
        });
    },
    createdOrigin(originData) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATED_ORIGIN,
            data: originData,
        });
    },
    createdDestination(destinationData) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATED_DESTINATION,
            data: destinationData,
        });
    },
    receiveMarket(market) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_MARKET,
            market,
        });
    },
    createMarketSuccess(market) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_MARKET_SUCCESS,
            market,
        });
    },
    createMarketFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_MARKET_FAIL,
            error,
        });
    },
    updateMarketSuccess(market) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_MARKET_SUCCESS,
            market,
        });
    },
    updateMarketFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_MARKET_FAIL,
            error,
        });
    },
    receiveMarkets(markets) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_MARKETS,
            markets,
        });
    },
    updatedPassword() {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_USER_PASSWORD,
        });
    },
    updatedPasswordFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_USER_PASSWORD_FAIL,
            error,
        });
    },
    searchCustomersSuccess(customers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SEARCH_CUSTOMERS_SUCCESS,
            customers,
        });
    },
    searchCustomersFail(errors) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SEARCH_CUSTOMERS_FAIL,
            errors,
        });
    },
    searchQuotesSuccess(quotes) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SEARCH_QUOTES_SUCCESS,
            quotes,
        });
    },
    searchQuotesFail(errors) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SEARCH_QUOTES_FAIL,
            errors,
        });
    },
    receiveCustomerSearch(customers) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CUSTOMER_SEARCH,
            customers,
        });
    },
    receiveCreatedDriver(driverData) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATED_DRIVER,
            driver: driverData,
        });
    },
    updatedCreditCard(userId, data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_CREDIT_CARD,
            id: userId,
            data,
        });
    },
    receiveCreditCards(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CREDIT_CARDS,
            data,
        });
    },
    updatedBankAccount(userId, data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATED_BANK_ACCOUNT,
            id: userId,
            data,
        });
    },
    updateBankAccountFailed(userId, data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_BANK_ACCOUNT_FAILED,
            id: userId,
            data,
        });
    },
    receiveBankAccounts(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_BANK_ACCOUNTS,
            data,
        });
    },
    createdCharge(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATED_CHARGE,
            data,
        });
    },
    createdPayout(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATED_PAYOUT,
            data,
        });
    },
    failedCharge(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FAILED_CHARGE,
            data,
        });
    },
    failedPayout(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FAILED_PAYOUT,
            data,
        });
    },
    receiveStripeCharges(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_STRIPE_CHARGES,
            data,
        });
    },
    receiveStripePayouts(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_STRIPE_PAYOUTS,
            data,
        });
    },
    stripeFunded(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.STRIPE_FUNDED,
            data,
        });
    },
    stripeFundingFailed(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.STRIPE_FUNDING_FAILED,
            data,
        });
    },
    receiveFrequentShippers(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_FREQUENT_SHIPPERS,
            data,
        });
    },
    receiveGrowthMetrics(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_GROWTH_METRICS,
            data,
        });
    },
    receiveDailyGrowthMetrics(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DAILY_GROWTH_METRICS,
            data,
        });
    },
    receiveDailyCustomerMetrics(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DAILY_CUSTOMER_METRICS,
            data,
        });
    },
    receiveDailyLookbackMetrics(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DAILY_LOOKBACK_METRICS,
            data,
        });
    },
    receiveTariff(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_TARIFF,
            data,
        });
    },
    receiveTariffs(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_TARIFFS,
            data,
        });
    },
    receiveAddTariffSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_TARIFF_SUCCESS,
            data,
        });
    },
    receiveUpdateTariffSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_TARIFF_SUCCESS,
            data,
        });
    },
    receiveUpdateTariffFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_TARIFF_FAIL,
            data,
        });
    },
    receiveRemoveTariffSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_TARIFF_SUCCESS,
            data,
        });
    },
    receiveRemoveTariffFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_TARIFF_FAIL,
            data,
        });
    },
    receiveUpdateShipperFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_SHIPPER_FAIL,
            data,
        });
    },
    receiveGetTariffsUsage(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_TARIFFS_USAGE,
            data,
        });
    },
    receiveAssignTariffSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ASSIGN_TARIFF_SUCCESS,
            data,
        });
    },
    receiveAssignTariffFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ASSIGN_TARIFF_FAIL,
            data,
        });
    },
    receiveUnassignTariffSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UNASSIGN_TARIFF_SUCCESS,
            data,
        });
    },
    receiveUnassignTariffFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UNASSIGN_TARIFF_FAIL,
            data,
        });
    },
    // TODO why do the price request and fail use 'get' but success uses 'receive' ????
    receivePrice(price) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_PRICE,
            price,
        });
    },
    getPriceFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_PRICE_FAIL,
            data,
        });
    },
    receiveDocument(key, doc) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DOCUMENT,
            data: { doc, key },
        });
    },
    receiveDocumentURIFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DOCUMENT_URI_FAIL,
            data,
        });
    },
    receiveDocumentURISuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DOCUMENT_URI_SUCCESS,
            data,
        });
    },
    receiveShipmentDistanceSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_DISTANCE_SUCCESS,
            data,
        });
    },
    receiveContracts(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_CONTRACTS,
            data,
        });
    },
    receiveAddContractSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_CONTRACT_SUCCESS,
            data,
        });
    },
    receiveUpdateContractSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_CONTRACT_SUCCESS,
            data,
        });
    },
    receiveUpdateContractFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_CONTRACT_FAIL,
            data,
        });
    },
    receiveTariffRate(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_TARIFFRATE,
            data,
        });
    },
    receiveTariffRates(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_TARIFFRATES,
            data,
        });
    },
    receiveAddTariffRateSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_TARIFFRATE_SUCCESS,
            data,
        });
    },
    receiveUpdateTariffRateSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_TARIFFRATE_SUCCESS,
            data,
        });
    },
    receiveUpdateTariffRateFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_TARIFFRATE_FAIL,
            data,
        });
    },
    receiveRemoveTariffRateSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_TARIFFRATE_SUCCESS,
            data,
        });
    },
    receiveRemoveTariffRateFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_TARIFFRATE_FAIL,
            data,
        });
    },
    receiveAccessorialRate(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ACCESSORIALRATE,
            data,
        });
    },
    receiveAccessorialRates(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ACCESSORIALRATES,
            data,
        });
    },
    receiveAddAccessorialRateSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_ACCESSORIALRATE_SUCCESS,
            data,
        });
    },
    receiveUpdateAccessorialRateSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ACCESSORIALRATE_SUCCESS,
            data,
        });
    },
    receiveUpdateAccessorialRateFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ACCESSORIALRATE_FAIL,
            data,
        });
    },
    receiveRemoveAccessorialRateSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_ACCESSORIALRATE_SUCCESS,
            data,
        });
    },
    receiveRemoveAccessorialRateFail(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_ACCESSORIALRATE_FAIL,
            data,
        });
    },
    downloadEquipmentCsv(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DOWNLOAD_EQUIPMENT_CSV,
            data,
        });
    },
    downloadOrdersCSV(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DOWNLOAD_ORDERS_CSV,
            data,
        });
    },
    downloadOrdersCSVSuccess() {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DOWNLOAD_ORDERS_CSV_SUCCESS,
        });
    },
    toggleDriverAuthorizationSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_DRIVER_AUTHORIZATION_SUCCESS,
            data,
        });
    },
    toggleDriverAuthorizationFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_DRIVER_AUTHORIZATION_FAIL,
            message,
        });
    },
    toggleReceiveOffersSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_RECEIVE_OFFERS_SUCCESS,
            data,
        });
    },
    toggleReceiveOffersFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_RECEIVE_OFFERS_FAIL,
            message,
        });
    },
    toggleCanSeePayoutSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_CAN_SEE_PAYOUT_SUCCESS,
            data,
        });
    },
    toggleCanSeePayoutFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_CAN_SEE_PAYOUT_FAIL,
            message,
        });
    },
    toggleMultiplePickupSuccess(data) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_MULTIPLE_PICKUP_SUCCESS,
            data,
        });
    },
    toggleMultiplePickupFail(message) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TOGGLE_MULTIPLE_PICKUP_FAIL,
            message,
        });
    },
    createDriverSuccess(driver) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_DRIVER_SUCCESS,
            driver,
        });
    },
    createDriverFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_DRIVER_FAIL,
            error,
        });
    },
    receiveShareShipmentSuccess(isSuccessful) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHARE_SHIPMENT,
            isSuccessful,
        });
    },
    receiveShipmentAuditSuccess(audits) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_SHIPMENT_AUDIT,
            audits,
        });
    },
    receiveOrderAuditSuccess(audits) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_AUDIT_SUCCESS,
            audits,
        });
    },
    receiveEquipmentAuditSuccess(payload) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_EQUIPMENT_AUDIT_SUCCESS,
            id: payload.id,
            audits: payload.response,
        });
    },
    receiveDriverWaypointsSuccess(waypoints) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DRIVER_WAYPOINTS,
            waypoints,
        });
    },
    bulkAddAccessorialsSuccess(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_ADD_ACCESSORIALS_SUCCESS,
            result,
        });
    },
    bulkAddAccessorialsFail(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_ADD_ACCESSORIALS_FAIL,
            result,
        });
    },
    getOrderTemplatesSuccess(templates) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_TEMPLATES_SUCCESS,
            templates,
        });
    },
    getOrderTemplatesFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_TEMPLATES_FAIL,
            error,
        });
    },
    getOrdersByQuerySearchSuccess(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ORDERS_SEARCH_SUCCESS,
            result,
        });
    },
    getOrdersByQuerySearchFail(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ORDERS_SEARCH_FAIL,
            result,
        });
    },
    updateShipmentAdjustmentsSuccess(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_SHIPMENT_ADJUSTMENTS_SUCCESS,
            result,
        });
    },
    setDriverFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SET_DRIVER_FAIL,
            error,
        });
    },
    setDriverSuccess() {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SET_DRIVER_SUCCESS,
        });
    },
    regenerateInvoiceSuccess(data) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.REGENERATE_INVOICE_SUCCESS,
            data,
        });
    },
    regenerateInvoiceFail(invoiceId, data) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.REGENERATE_INVOICE_FAIL,
            invoiceId,
            data,
        });
    },
    updateInvoiceSuccess(data) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.UPDATE_INVOICE_SUCCESS,
            data,
        });
    },
    updateInvoiceFail(invoiceId, data) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.UPDATE_INVOICE_FAIL,
            invoiceId,
            data,
        });
    },
    getShipmentsById(data) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.GET_SHIPMENTS_BY_ID,
            data,
        });
    },
    getShipmentsForBulkLFD(data) {
        AdminAppDispatcher.handleViewAction({
            type: ActionTypes.GET_SHIPMENTS_BY_ID,
            data,
        });
    },
    getTripsSuccess(trips) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_TRIPS_SUCCESS,
            trips,
        });
    },
    getTripsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_TRIPS_FAIL,
            error,
        });
    },
    createTripSuccess(trip) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_TRIP_SUCCESS,
            trip,
        });
    },
    createTripFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_TRIP_FAIL,
            error,
        });
    },
    updateTripSuccess(trip) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_TRIP_SUCCESS,
            trip,
        });
    },
    updateTripFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_TRIP_FAIL,
            error,
        });
    },
    saveAndApplyTripSuccess({ order, trip }) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SAVE_AND_APPLY_TRIP_SUCCESS,
            order,
            trip,
        });
    },
    saveAndApplyTripFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SAVE_AND_APPLY_TRIP_FAIL,
            error,
        });
    },
    generateTripSuccess(trip) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_TRIP_SUCCESS,
            trip,
        });
    },
    generateTripFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GENERATE_TRIP_FAIL,
            error,
        });
    },
    updateStopEquipmentsSuccess(job) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_STOP_EQUIPMENTS_SUCCESS,
            job,
        });
    },
    updateStopEquipmentsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_STOP_EQUIPMENTS_FAIL,
            error,
        });
    },
    getOrderShipmentsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_SHIPMENTS_SUCCESS,
            response,
        });
    },
    getOrderShipmentsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_ORDER_SHIPMENTS_FAIL,
            error,
        });
    },
    updateException(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_EXCEPTION,
            result,
        });
    },
    updateExceptionFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_EXCEPTION_FAIL,
            error,
        });
    },
    removeFavoriteLocationSuccess(shipperId, locationId) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_FAVORITE_LOCATION_SUCCESS,
            shipperId,
            locationId,
        });
    },
    removeFavoriteLocationFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.REMOVE_FAVORITE_LOCATION_FAIL,
            error,
        });
    },
    transitionShipmentSuccess(shipment) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TRANSITION_SHIPMENT_SUCCESS,
            shipment,
        });
    },
    transitionShipmentFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.TRANSITION_SHIPMENT_FAIL,
            error,
        });
    },
    shareShipmentSuccess() {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SHARE_SHIPMENT_SUCCESS,
        });
    },
    shareShipmentFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.SHARE_SHIPMENT_FAIL,
            error: response.error,
        });
    },
    bulkUpdateDatesSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_DATES_SUCCESS,
            response,
        });
    },
    bulkUpdateDatesFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_DATES_FAIL,
            error,
        });
    },
    bulkUpdateNotesSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_NOTES_SUCCESS,
            response,
        });
    },
    bulkUpdateSpecialInstructionsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_SPECIAL_INSTRUCTIONS_SUCCESS,
            response,
        });
    },
    bulkUpdateNotesFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_NOTES_FAIL,
            error,
        });
    },
    bulkUpdateSpecialInstructionsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_SPECIAL_INSTRUCTIONS_FAIL,
            error,
        });
    },
    bulkUpdateShipmentsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_SHIPMENTS_SUCCESS,
            response,
        });
    },
    bulkUpdateShipmentsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_SHIPMENTS_FAIL,
            error,
        });
    },
    bulkUpdateReferenceSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_REFERENCE_SUCCESS,
            response,
        });
    },
    bulkUpdateReferenceFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_REFERENCE_FAIL,
            error,
        });
    },
    onBulkUpdateCarrierCostsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_CARRIER_COSTS_SUCCESS,
            response,
        });
    },
    onUpdateAccessorialRequestFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ACCESSORIAL_REQUEST_FAIL,
            response,
        });
    },
    onUpdateAccessorialRequestSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ACCESSORIAL_REQUEST_SUCCESS,
            response,
        });
    },
    onGetAccessorialPaginatedRequestsFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ACCESSORIAL_PAGINATED_REQUEST_FAIL,
            response,
        });
    },
    onGetAccessorialPaginatedRequestsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ACCESSORIAL_PAGINATED_REQUEST_SUCCESS,
            response,
        });
    },
    onGetAccessorialRequestsFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ACCESSORIAL_REQUEST_FAIL,
            response,
        });
    },
    onGetAccessorialRequestsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_ACCESSORIAL_REQUEST_SUCCESS,
            response,
        });
    },
    onUploadAccessorialDocSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPLOAD_ACCESSORIAL_DOC_SUCCESS,
            response,
        });
    },
    onUploadAccessorialDocFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPLOAD_ACCESSORIAL_DOC_FAIL,
            response,
        });
    },
    onAddAccessorialSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ADD_ACCESSORIAL_SUCCESS,
            response,
        });
    },
    onBulkUpdateCarrierCostsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_UPDATE_CARRIER_COSTS_FAIL,
            error,
        });
    },
    getCustomersFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.GET_CUSTOMERS_FAIL,
            error,
        });
    },
    downloadCustomersCsvFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DOWNLOAD_CUSTOMERS_CSV_FAIL,
            error,
        });
    },
    fetchCustomerAuditsSuccess(audits) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_CUSTOMER_AUDITS_SUCCESS,
            audits,
        });
    },
    fetchCustomerAuditsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.FETCH_CUSTOMER_AUDITS_FAIL,
            error,
        });
    },
    createAccessorialRequestSuccess(exception) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ACCESSORIAL_REQUEST_SUCCESS,
            exception,
        });
    },
    createAccessorialRequestFail(err) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ACCESSORIAL_REQUEST_FAIL,
            err,
        });
    },
    bulkCreateAccessorialRequestSuccess(result) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_SUCCESS,
            result,
        });
    },
    bulkCreateAccessorialRequestFail(err) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.BULK_CREATE_ACCESSORIAL_REQUEST_FAIL,
            err,
        });
    },
    createAccessorialExceptionSuccess(exception) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ACCESSORIAL_EXCEPTION_SUCCESS,
            exception,
        });
    },
    createAccessorialExceptionFail(err) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.CREATE_ACCESSORIAL_EXCEPTION_FAIL,
            err,
        });
    },
    updateAccessorialExceptionSuccess(exception) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ACCESSORIAL_EXCEPTION_SUCCESS,
            exception,
        });
    },
    updateAccessorialExceptionFail(err) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_ACCESSORIAL_EXCEPTION_FAIL,
            err,
        });
    },
    acceptAccessorialsFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ACCEPT_ACCESSORIALS_FAIL,
            response,
        });
    },
    acceptAccessorialsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.ACCEPT_ACCESSORIALS_SUCCESS,
            response,
        });
    },
    approveAccessorialsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.APPROVE_ACCESSORIALS_SUCCESS,
            response,
        });
    },
    approveAccessorialsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.APPROVE_ACCESSORIALS_FAIL,
            error,
        });
    },
    declineAccessorialsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DECLINE_ACCESSORIALS_SUCCESS,
            response,
        });
    },
    declineAccessorialsFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.DECLINE_ACCESSORIALS_FAIL,
            error,
        });
    },
    updateDeliveryOrderStatusSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_DELIVERY_ORDER_STATUS_SUCCESS,
            response,
        });
    },
    updateDeliveryOrderStatusFail(error) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.UPDATE_DELIVERY_ORDER_STATUS_FAIL,
            error,
        });
    },
    receiveDrayageOfferSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DRAYAGE_OFFER_SUCCESS,
            response,
        });
    },
    receiveDrayageOfferFail(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RECEIVE_DRAYAGE_OFFER_FAIL,
            response,
        });
    },
    rerateCostsSuccess(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RERATE_SHIPMENT_COSTS_SUCCESS,
            response,
        });
    },
    rerateCostsFailure(response) {
        AdminAppDispatcher.handleServerAction({
            type: ActionTypes.RERATE_SHIPMENT_COSTS_FAILURE,
            response,
        });
    },
};
